/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/ban-ts-comment */
//@ts-nocheck
import { Message } from 'ais-facade-api/api';
import { useState, useCallback, createContext } from 'react';

export const AlertContext = createContext({
  alert: {
    data: {
      messages: [
        {
          code: 0,
          id: '',
          description: '',
          type: undefined,
          timestamp: '',
        },
      ],
    },
  },
  addAlert: (e) => { },
  removeAlert: () => { },
});

export const AlertProvider = ({ children }: any) => {
  const [alert, setAlert] = useState<null | Message>(null);
  const removeAlert = () => {
    setAlert(null);
  };

  const addAlert = (message: Message) => {
    setAlert(message);
  };

  const contextValue = {
    alert,
    addAlert: useCallback((message: Message) => addAlert(message), []),
    removeAlert: useCallback(() => removeAlert(), []),
  };

  return <AlertContext.Provider value={contextValue}>{children}</AlertContext.Provider>;
};
